module.exports = __webpack_public_path__ + "static/img/kongtiao-zhileng.151fceba.png";